import type { Router } from "vue-router";
import { onStatisticsConsent, type ConsentHost } from "@ai-platform/ui/consent.ts";

/*
 * When Faro starts in the portal (ADR-141 points 4 and 5): once the visitor agrees to
 * "Statistik", at once when they already have, else at the moment they do. Until then the SDK is
 * not even loaded: `src/lib/faro.ts` is its own chunk, fetched by the dynamic import. No consent,
 * or no consent manager, means nothing loads. There is no switch of its own: without a receiver
 * NGINX answers /__faro/collect itself and forwards nothing.
 */

type FaroModule = { startFaro: (router: Router) => unknown };

export type MonitoringOptions = {
  /** Loads the Faro module; tests pass their own. */
  load?: () => Promise<FaroModule>;
  /** Where the consent manager lives; tests pass their own. */
  host?: ConsentHost;
};

/** Starts Faro once, after consent to "Statistik". A failed load leaves the portal untouched. */
export function monitorAfterConsent(router: Router, options: MonitoringOptions = {}): void {
  const load = options.load ?? (() => import("./faro.ts"));
  let started = false;
  onStatisticsConsent(() => {
    if (started) return;
    started = true;
    // Telemetry never breaks the portal: a chunk that fails to load is simply no telemetry.
    load()
      .then(({ startFaro }) => startFaro(router))
      .catch(() => undefined);
  }, options.host);
}
